import { PassengersPageId } from '../../../features/app/pages/domain/constants/PageId';
import { getStaticPathsForLocales } from '../../../features/app/pages/domain/use-cases/getStaticPathsForLocales';
import { createGetStaticPropsWithPage } from '../../../features/app/root/domain/use-cases/createGetStaticPropsWithPage';
import { ShopDineAndRelaxDetailPage } from '../../../features/shop-dine-and-relax/ui/detail';

export const getStaticPaths = getStaticPathsForLocales;

export const getStaticProps = createGetStaticPropsWithPage(
	PassengersPageId.ShopDineAndRelaxDetail,
);

export default ShopDineAndRelaxDetailPage;
